import { jerusalemToday } from "./jerusalemDay";

// A due date is an Israel calendar date, not a UTC timestamp.
// The last allowed instant is 23:59:59 on the selected date.
export function isTicketOverdue(ticket, now = new Date()) {
  if (!ticket?.due_date || !ticket?.technician_id) return false;
  if (["closed", "merged"].includes(ticket.status)) return false;
  const date = String(ticket.due_date).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(date) && date < jerusalemToday(now);
}
